import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfGodown from './confGodown/ConfGodown'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import {connect} from 'react-redux'
import {getGoDown} from '../../containers/app/actions'
import SplitButton from "../utils/SplitButton/SplitButton.js";


const GoDown = (props) => { 
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")

  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeGoDown,setGoDown] = React.useState(false) 

  React.useEffect(() => {
    props.getGoDown(props.user._id)
  },[]);
 

  React.useEffect(() => {
    if(props.goDown) {
      let arr = [];
      arr = props.goDown.filter(val => {
        if(val.name.toLowerCase().includes(searchValue.toLowerCase())) {
          return val;
        }
      }) 
      setFilteredData(arr);
    } else {
      setFilteredData(false);
    }
  },[searchValue,props.goDown]);


  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteGodown",
      data: {
        godownId: value._id,
        userId: props.user._id
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      props.getGoDown(props.user._id);
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  
  !isLoading && filteredData.forEach(val => {
    details.push(
      [
        val._id,
        val.name,
        val.uniqueCode, 
        <React.Fragment>  
          <IconButton onClick={() => {
            setGoDown(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>

          <IconButton onClick={() => handleDelete(val)}>
            <DeleteRoundedIcon />
          </IconButton>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      <ConfGodown
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          props.getGoDown(props.user._id)
        }}
        setAlert={(msg) => setAlert(msg)}
      />
      {activeGoDown && <ConfGodown 
        type="EDIT"
        goDown={activeGoDown} 
        open={editModal} 
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setGoDown(false)
          props.getGoDown(props.user._id)
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>
 
      <TopBar 
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  


        nav={[
          {Name: "WareHouse",onClick: () => props.history.push("/admin/warehouses")},
          {Name: "Godown",onClick: () => {}}
        ]}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Godown</h4> 

              <div className={style.buttons}>
                <SplitButton
                  options={
                    [ {name: "Godown",onClick: () => props.history.push("/admin/godown")},
                      {name: "Location",onClick: () => props.history.push("/admin/location")}, 
                    ]
                  }
                  name={"Explore"}
                  color="secondary"
                />

                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Godown</Button> 
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["#Id", "Name", "Code","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user,
  goDown: state.appReducer.goDown, 
})
export default withRouter(connect(mapStateToProps, {getGoDown})(GoDown));